import { useEffect, useState } from "react";
import { DivTablePage } from "../../components/common/DivTablePage";
import { VeryBtnFill } from "../../components/common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../components/common/v2/VeryBtnFill/classVeryBtnFill";
import { VeryCheckbox } from "../../components/common/v2/VeryCheckbox";
import { VeryIconGoogle } from "../../components/common/v2/VeryIconGoogle";
import { classVeryIconGoogle } from "../../components/common/v2/VeryIconGoogle/classVeryIconGoogle";
import { VerySwitch } from "../../components/common/v2/VerySwitch";
import { VeryTable } from "../../components/common/v2/VeryTable";
import { CellTooltip } from "../../components/common/v2/VeryTable/CellTooltip";
import StylesCellTooltip from "../../components/common/v2/VeryTable/CellTooltip/styles";
import classVeryTable from "../../components/common/v2/VeryTable/classVeryTable";
import { useDynamicRateContext } from "../../context";
import { isStringEmpty } from "../../utils/handler_validations";
import styles from "./styles";
import { GeofenceMap } from "@wallavi/very-geofencing-library";
import ContainerRightRate from "../../components/dynamic-rate/ContainerLeftEditRate";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const propsPage = () => ({
  isLoaded: false,
});

const ContentDynamicRoutes = (props = propsPage()) => {
  const rates = useDynamicRateContext();
  console.log("rates", rates.value.list);
  const [modeView, setModeView] = useState("list");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const MEXICO_CENTER = { lat: 23.6345, lng: -102.5528 };
  const [center, setCenter] = useState(MEXICO_CENTER);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          setCenter({ lat, lng: lon });
        },
        function (error) {
          console.error("Error al obtener la ubicación:", error.message);
        },
      );
    }
  }, []);

  return (
    <>
      <styles.DivMain
        isLoading={rates.value.page.loading}
        error={rates.value.page.error}
        onClickBtnRetry={() => rates.getListInitial()}
      >
        {rates.rowSelected < 0 ? (
          <div className="containerLeft">
            <div className="divHeader">
              <div className="divRate" style={{ cursor: "pointer", transition: "all 0.2s" }} onClick={() => rates.onChangeRowSelected("GENERAL")}>
                <div className="divRateTitle">
                  <VeryIconGoogle
                    name="paid"
                    type={classVeryIconGoogle.ICON_TYPE.FILLED}
                    size={25}
                    color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                  />
                  <span>Tarifa General (Clic para editar)</span>
                  <Tooltip
                    className="tooltip"
                    title="Tarifa inicial general es el precio asignado por la aplicacion a nivel general. Haga clic aquí para editar."
                    placement="top"
                  >
                    <div>
                      <VeryIconGoogle
                        name="info"
                        type={classVeryIconGoogle.ICON_TYPE.OUTLINED}
                        size={20}
                        color={classVeryIconGoogle.ICON_COLOR.GRAY_S1}
                      />
                    </div>
                  </Tooltip>
                </div>
                <div className="divRateValue" style={{ marginTop: "4px" }}>
                  <span style={{ fontSize: "14px", fontWeight: "600" }}>${rates.generalBasePrice}.00 (hasta {rates.generalBaseKm} km) + ${rates.generalExtraKmPrice}.00 / km extra</span>
                </div>
              </div>
            </div>

            <styles.ContentContainer>
              <div
                className="containerTable"
                style={{
                  height: rates.value.list.length === 0 && "65vh",
                }}
              >
                <div className="containerHeaderTable">
                  <span className="txtTitle">Tarifa dinámica</span>
                  <div className="divButtons">
                    {modeView === "list" ? (
                      <VeryBtnFill
                        colorTheme={classVeryBtnFill.COLOR_THEME.WHITE_S1}
                        icon={{
                          name: "map",
                          size: 20,
                          type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
                        }}
                        onClick={() => setModeView("map")}
                      />
                    ) : (
                      <VeryBtnFill
                        colorTheme={classVeryBtnFill.COLOR_THEME.WHITE_S1}
                        icon={{
                          name: "list",
                          size: 20,
                          type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
                        }}
                        onClick={() => setModeView("list")}
                      />
                    )}
                    <VeryBtnFill
                      isDisabled={rates.selectedRateIds.length === 0}
                      colorTheme={classVeryBtnFill.COLOR_THEME.WHITE_S1}
                      onClick={() => setShowDeleteConfirm(true)}
                      icon={{
                        name: "delete",
                        size: 20,
                        type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_OUTLINED,
                      }}
                    />
                    <VeryBtnFill
                      label="Agregar"
                      icon={{
                        name: "add_circle",
                        size: 18,
                        type: classVeryIconGoogle.ICON_TYPE.SYMBOLS_FILLED,
                      }}
                      onClick={() => rates.showModalAdd()}
                    />
                  </div>
                </div>
                <hr />
                {modeView === "list" ? (
                  <div
                    style={{
                      marginTop: rates.value.list.length === 0 && "150px",
                    }}
                  >
                    <DivTablePage
                      isLoading={rates.value.contentPage.loading}
                      error={rates.value.contentPage.error}
                      onClickBtnRetry={() => rates.getListFiltered()}
                      emptyMessage={rates.getEmptyMsgPage()}
                    >
                      <VeryTable
                        CSS={["couponsTable"]}
                        rows={rates.value.list}
                        getRowId={(row) => row.rowId}
                        disabledRowSelection={false}
                        rowSelected={rates.rowSelected}
                        onChangeRowSelected={(newRowSelected) => {
                          rates.onChangeRowSelected(newRowSelected);
                          const dataRate = rates.value.list.find(
                            (item) => item.rowId === newRowSelected,
                          );
                          if (!dataRate) return;
                          rates.showContainerModeEdit(dataRate);
                        }}
                        columns={{
                          //column checbkox
                          col_checkbox: classVeryTable.getColumnTemplate(
                            <VeryCheckbox
                              selected={
                                rates.selectedRateIds.length ===
                                rates.value.list.length
                              }
                              onChangeSelected={(selected) => {
                                if (selected) {
                                  const allIds = rates.value.list.map(
                                    (item) => item.id,
                                  );
                                  rates.setSelectedRateIds(allIds);
                                } else {
                                  rates.setSelectedRateIds([]);
                                }
                              }}
                            />,
                            "Seleccionar",
                            1,
                            50,
                            50,
                            false,
                            false,
                            (params) => params.row.id,
                            (params) => {
                              const isSelected = rates.selectedRateIds.includes(
                                params.value,
                              );
                              return (
                                <VeryCheckbox
                                  selected={isSelected}
                                  onChangeSelected={(selected) => {
                                    if (selected) {
                                      rates.setSelectedRateIds((prev) => [
                                        ...prev,
                                        params.value,
                                      ]);
                                    } else {
                                      rates.setSelectedRateIds((prev) =>
                                        prev.filter(
                                          (id) => id !== params.value,
                                        ),
                                      );
                                    }
                                  }}
                                />
                              );
                            },
                          ),
                          //column activate
                          col_activate: classVeryTable.getColumnTemplate(
                            "Off/On",
                            "Activar/Desactivar",
                            1,
                            100,
                            70,
                            false,
                            false,
                            (params) => {
                              return params.row.isActivate;
                            },
                            (params) => {
                              return (
                                <VerySwitch
                                  selected={params.value}
                                  onChangeSelected={(selected) => {
                                    rates.onClickBtnActivate({
                                      ...params.row,
                                      isActivate: selected,
                                    });
                                  }}
                                />
                              );
                            },
                          ),
                          //column name
                          col_name: classVeryTable.getColumnTemplate(
                            "Nombre",
                            "Nombre de la tarifa",
                            1,
                            150,
                            150,
                            true,
                            true,
                            (params) => {
                              return isStringEmpty(params?.row?.name)
                                ? "Desconocido"
                                : params.row.name;
                            },
                            (params) => {
                              return (
                                <CellTooltip
                                  divCellCSS={["cellCode"]}
                                  contentCell={
                                    <StylesCellTooltip.LabelCell className="txtCode">
                                      {params.value}
                                    </StylesCellTooltip.LabelCell>
                                  }
                                  contentTooltip={
                                    <StylesCellTooltip.LabelTooltip>
                                      {params.value}
                                    </StylesCellTooltip.LabelTooltip>
                                  }
                                />
                              );
                            },
                          ),
                          //column ubication
                          col_ubication: classVeryTable.getColumnTemplate(
                            "Ubicación",
                            "Ubicación de la tarifa",
                            1,
                            140,
                            140,
                            true,
                            true,
                            (params) => {
                              return isStringEmpty(params?.row?.ubicationName)
                                ? "Desconocido"
                                : params.row.ubicationName;
                            },
                            (params) => {
                              return (
                                <CellTooltip
                                  divCellCSS={["cellCode"]}
                                  contentCell={
                                    <StylesCellTooltip.LabelCell className="txtCode">
                                      {params.value}
                                    </StylesCellTooltip.LabelCell>
                                  }
                                  contentTooltip={
                                    <StylesCellTooltip.LabelTooltip>
                                      {params.value}
                                    </StylesCellTooltip.LabelTooltip>
                                  }
                                />
                              );
                            },
                          ),
                          //column initial rate
                          col_initial_rate: classVeryTable.getColumnTemplate(
                            "Tarifa Inicial",
                            "Tarifa Inicial",
                            1,
                            140,
                            140,
                            true,
                            true,
                            (params) => {
                              return params.row.initialRate;
                            },
                            (params) => {
                              return classVeryTable.renderColMoney(
                                params.value,
                                2,
                              );
                            },
                          ),
                          //column rate per km
                          col_rate_per_km: classVeryTable.getColumnTemplate(
                            "Tarifa D./ Km",
                            "Tarifa por km",
                            1,
                            140,
                            140,
                            true,
                            false,
                            (params) => {
                              return {
                                pricePerKilometer: params.row.pricePerKilometer,
                                Kilometers: params.row.kilometers,
                              };
                            },
                            (params) => {
                              return (
                                <>
                                  <span>
                                    {classVeryTable.renderColMoney(
                                      params.value.pricePerKilometer,
                                      2,
                                    )}
                                  </span>
                                  <span> / </span>
                                  <span>{params.value.Kilometers}</span>
                                </>
                              );
                            },
                          ),
                          //column rate per schedule
                          col_rate_per_schedule:
                            classVeryTable.getColumnTemplate(
                              "Tarifa por horario",
                              "Tarifa por horario",
                              1,
                              180,
                              180,
                              true,
                              false,
                              (params) => {
                                return {
                                  startHour: params.row.startHour,
                                  endHour: params.row.endHour,
                                  priceOnDemand: params.row.priceOnDemand,
                                };
                              },
                              (params) => {
                                const formatHour = (time) => {
                                  const [hour, , period] = time.split(/[:\s]/); // Separa la hora y el AM/PM
                                  return `${hour} ${period}`; // Retorna solo la hora y el AM/PM
                                };

                                return (
                                  <>
                                    <span>
                                      {classVeryTable.renderColMoney(
                                        params.value.priceOnDemand,
                                        2,
                                      )}
                                    </span>
                                    <span> / </span>
                                    <span>
                                      {formatHour(params.value.startHour)} -{" "}
                                      {formatHour(params.value.endHour)}
                                    </span>
                                  </>
                                );
                              },
                            ),
                          //column color rate
                          col_color_rate: classVeryTable.getColumnTemplate(
                            "Color",
                            "Color de Tarifa",
                            1,
                            100,
                            95,
                            true,
                            true,
                            (params) => {
                              return params.row.color;
                            },
                            (params) => {
                              return (
                                <div
                                  style={{
                                    backgroundColor: params.value,
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                  }}
                                />
                              );
                            },
                          ),
                          //column created by
                          col_created_by: classVeryTable.getColumnTemplate(
                            "Creado por",
                            "Creado por",
                            1,
                            200,
                            110,
                            true,
                            true,
                            (params) => {
                              return params.row.createdBy;
                            },
                            (params) => {
                              return (
                                <CellTooltip
                                  divCellCSS={["cellCode"]}
                                  contentCell={
                                    <StylesCellTooltip.LabelCell className="txtCode">
                                      {params.value}
                                    </StylesCellTooltip.LabelCell>
                                  }
                                  contentTooltip={
                                    <StylesCellTooltip.LabelTooltip>
                                      {params.value}
                                    </StylesCellTooltip.LabelTooltip>
                                  }
                                />
                              );
                            },
                          ),
                        }}
                      />
                    </DivTablePage>
                  </div>
                ) : (
                  <div>
                    <GeofenceMap
                      height={"65vh"}
                      width={"100%"}
                      mode="view"
                      center={center}
                      dynamicRates={rates.value.list}
                      isLoaded={props.isLoaded}
                      onEditGeofence={(rate) => {
                        const item = rates.value.list.find(
                          (r) => r.id === rate.id,
                        );
                        if (!item) return;
                        setModeView("list");
                        rates.onChangeRowSelected(item.rowId);
                        rates.showContainerModeEdit(item);
                      }}
                    />
                  </div>
                )}
              </div>
            </styles.ContentContainer>
          </div>
        ) : (
          <>
            <ContainerRightRate isLoaded={props.isLoaded} />
          </>
        )}
      </styles.DivMain>

      <Dialog
        open={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
      >
        <DialogTitle>Eliminar rutas dinámicas</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar{" "}
            {rates.selectedRateIds.length === 1
              ? "esta ruta dinámica"
              : `estas ${rates.selectedRateIds.length} rutas dinámicas`}
            ? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDeleteConfirm(false)}>Cancelar</Button>
          <Button
            color="error"
            onClick={() => {
              setShowDeleteConfirm(false);
              rates.onClickBtnDelete();
            }}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContentDynamicRoutes;
